import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { api, ApiError } from './api-client';
import type { CurrentUser } from './auth';

// Loads the current user from /api/v1/auth/me. While loading: spinner. On success: render the child
// routes with the user available via useOutletContext. On a 401 the loading text stays: the request
// already went through ForceSignOutHandler, which redirects to /login with the page to return to,
// and a redirect here as well would race it and drop that page. Any other failure (network, 5xx)
// redirects to /login.
export function RequireAuth() {
  const [user, setUser] = useState<CurrentUser | null | undefined>(undefined);

  useEffect(() => {
    api
      .get<CurrentUser>('/v1/auth/me')
      .then(setUser)
      .catch((err: unknown) => {
        if (err instanceof ApiError && err.status === 401) {
          return;
        }
        setUser(null);
      });
  }, []);

  if (user === undefined) {
    return <div className="p-8 text-sm text-slate-500">Loading...</div>;
  }
  if (user === null) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet context={user satisfies CurrentUser} />;
}
